import {
  Heading,
  Button,
  Collapse,
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  VStack,
  Center,
  Image,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "./authContext";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { Text } from "@chakra-ui/react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import Swal from "sweetalert2";
import { useLanguage } from "./languageContext";
import LanguageSwitch from "./LanguageSwitch";
import LandingNav from "./LandingNav";

interface loginD {
  email: string;
  password: string;
}

const LoginPage = () => {
  // Initialize
  const { login, currentUser } = useAuthContext();
  console.log(currentUser);
  const { language, toggleLanguage } = useLanguage();

  const [showPassword, setShowPassword] = useState(false);
  const [showResetPassword, setResetPassword] = useState(false);

  // const [error, setError] = useState('')
  const navigate = useNavigate();
  const [resetEmail, setResetEmail] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);
  const auth = getAuth();
  const triggerResetEmail = async () => {
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      console.log("Password reset email sent");
      Swal.fire("Password reset email sent", "success");
      setResetSuccess(true);
    } catch (error) {
      console.error("Error sending password reset email:", error);
      Swal.fire("Error", "Error sending password reset email:", "error");
    }
  };

  useEffect(() => {
    if (currentUser) {
      console.log("waiting for more data!");
      navigate("/flora");
    }
  }, [currentUser, navigate]);

  // Form Logic
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<loginD>();
  const onSubmit: SubmitHandler<loginD> = async (data) => {
    try {
      // setError('')
      // console.log(("waiting for more data!"), 20000);
      await login(data.email, data.password);
      navigate("/flora");
    } catch {
      //setError('login')//
      Swal.fire(
        language === "english" ? "Error" : "Error",
        language === "english"
          ? "Please Try again, Wrong information entered"
          : "Por favor, inténtelo de nuevo, información incorrecta",
        "error"
      );
    }
  };

  return (
    <Box
      backgroundImage={"url(bg.svg)"}
      backgroundSize="cover"
      minH="100vh"
      minWidth="100vw"
      width={{ base: "100%", sm: "100%", md: "100%", lg: "100%", xl: "100%" }}
      justifyContent="fixed"
      alignItems="center"
    >
      <LandingNav />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack direction={{ base: "column", md: "row" }}>
          <Stack
            display="flex"
            direction="column"
            alignItems="left"
            justifyContent="center"
            p={2}
            pl={{base:4, md:10, xl:20}}
            pt={{base:20, md:60, xl:300}}
            minWidth={{ base: "50%", md: "20%" }}
          >
            <Heading
              fontSize= {{ base: "40px", sm: "100px", md: "60px", lg: "75px", xl: "80px", "2xl": "100px"}}
              color="white"
            >
              {language === "english"
                ? "Junglekeepers Data Hub"
                : "Centro de Datos de \n Junglekeepers"}
            </Heading>
            <Text
              fontSize={{ base: "10px", sm: "15px", xl: "20px"}}
              color="white"
              maxW={{ base: "70%", sm: "70%" }}
              display={{
                base: "none",
                sm: "none",
                md: "block",
                lg: "block",
                xl: "block",
                "2xl": "block",
              }}
            >
              {language === "english"
                ? "A centralized space designed to enhance wildlife conservation \
              efforts in the Peruvian Amazon. Developed in partnership with\
              McGill University, this platform integrates data analysis to monitor biodiversity and detect \
              threats across nearly 55,000 acres of the Madre de Dios region. \
              "
                : "Un espacio centralizado diseñado para mejorar los esfuerzos de conservación de la vida silvestre en la Amazonía peruana. Desarrollado en colaboración con la Universidad McGill, esta plataforma integra el análisis de datos para monitorear la biodiversidad y detectar amenazas en casi 55,000 acres de la región de Madre de Dios."}
            </Text>
          </Stack>
          <Box
            pt={{ base: 0, md: 40 }}
            pb={10}

            // pl={{ base: 10, sm: 80, md: 80, lg: 40, xl: 120, "2xl": 120 }}
            pl={10}
            pr={10}
            display="block"
            width={{
              base: "100%",
              sm: "100%",
              md: "150%",
              lg: "150%",
              xl: "150%",
              "2xl": "80%",
            }}
          >
            <VStack
              spacing={4}
              rounded="md"
              bg="white"
              border="1px"
              borderColor={"gray.200"}
              shadow="lg"
              p={2}
              minW={{ base: 10, sm: 10, md: 40, lg: 50 }}
              // maxW={{ base: 100, sm: 50, md: 100, lg: "80%" }}
            >
              <Box textAlign="right"></Box>
              <Box
                flexShrink={0}
                width={{
                  base: "80%",
                  sm: "60%",
                  md: "60%",
                  lg: "80%",
                  xl: "80%",
                  "2xl": "60%",
                }}
              >
                <Stack direction="row" spacing="10px" align="center">
                  <Image
                    width={{
                      base: "10%",
                      sm: "20%",
                      md: "20%",
                      lg: "20%",
                      xl: "20%",
                      "2xl": "20%",
                    }}
                    src="/JKLogoBlack.webp"
                    alt="Logo 1"
                    mr="4"
                  />
                  <Image
                    width={{
                      base: "60%",
                      sm: "80%",
                      md: "80%",
                      lg: "80%",
                      xl: "80%",
                      "2xl": "80%",
                    }}
                    src="/McGill.jpeg"
                    alt="Logo 2"
                  />
                </Stack>
              </Box>
              <Heading
                fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
                transition={"all 0.5s ease"}
              >
                {language === "english" ? "LOGIN" : "INICIAR SESIÓN"}
              </Heading>

              {/* EMAIL */}
              <FormControl isInvalid={Boolean(errors.email)}>
                <FormLabel fontWeight="700">
                  {language === "english" ? "EMAIL" : "CORREO ELECTRÓNICO"}
                </FormLabel>
                <Input
                  type="email"
                  {...register("email", {
                    required:
                      language === "english"
                        ? "This field is required"
                        : "Este campo es obligatorio",
                  })}
                />
                <FormErrorMessage fontWeight={700}>
                  {language === "english"
                    ? "This field is required"
                    : "Este campo es obligatorio"}
                </FormErrorMessage>
              </FormControl>

              {/* PASSWORD */}
              <FormControl isInvalid={Boolean(errors.password)}>
                <FormLabel fontWeight="700">
                  {language === "english" ? "PASSWORD" : "CONTRASEÑA"}
                </FormLabel>
                <InputGroup>
                  <Input
                    focusBorderColor="charcoal.500"
                    {...register("password", {
                      required:
                        language === "english"
                          ? "This field is required"
                          : "Este campo es obligatorio",
                    })}
                    type={showPassword ? "text" : "password"} // Use the state to toggle password visibility
                  />
                  <InputRightElement>
                    {/* IconButton to toggle password visibility */}
                    <IconButton
                      icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                      variant="ghost"
                      aria-label={
                        showPassword
                          ? language === "english"
                            ? "Hide password"
                            : "Ocultar contraseña"
                          : language === "english"
                          ? "Show password"
                          : "Mostrar contraseña"
                      }
                      onClick={() =>
                        setShowPassword((prevShowPassword) => !prevShowPassword)
                      }
                    />
                  </InputRightElement>
                </InputGroup>
                <FormErrorMessage fontWeight={700}>
                  {language === "english"
                    ? "This field is required"
                    : "Este campo es obligatorio"}
                </FormErrorMessage>
              </FormControl>

              {/* LOGIN BUTTON */}
              <Button type="submit" w="100%" size={"lg"}>
                {language === "english" ? "LOGIN" : "INICIAR SESIÓN"}
              </Button>

              <Button
                onClick={() => setResetPassword(!showResetPassword)}
                variant="link"
                mt={2}
              >
                {language === "english"
                  ? "Reset Password"
                  : "Restablecer la contraseña"}
              </Button>
              <Collapse in={showResetPassword} animateOpacity>
                <Box
                  p="40px"
                  color="black"
                  mt="4"
                  bg="gray.50"
                  rounded="md"
                  shadow="md"
                >
                  <FormControl>
                    <FormLabel fontWeight="700" marginBottom="20px">
                      {language === "english"
                        ? "Reset Password"
                        : "Restablecer la contraseña"}
                    </FormLabel>
                    <Input
                      marginBottom="20px"
                      type="email"
                      placeholder={
                        language === "english"
                          ? "Enter your email"
                          : "Introduce tu correo electrónico"
                      }
                      value={resetEmail}
                      onChange={(e) => setResetEmail(e.target.value)}
                    />
                    {resetSuccess && (
                      <FormErrorMessage fontWeight={700} color="green">
                        {language === "english"
                          ? "Password reset email sent!"
                          : "¡Correo electrónico de restablecimiento de contraseña enviado!"}
                      </FormErrorMessage>
                    )}
                  </FormControl>

                  <Button
                    type="button"
                    onClick={triggerResetEmail}
                    w="100%"
                    size="lg"
                    colorScheme="green"
                  >
                    {language === "english"
                      ? "Reset Password"
                      : "Restablecer la contraseña"}
                  </Button>
                </Box>
              </Collapse>
            </VStack>
          </Box>
        </Stack>
      </form>
    </Box>
  );
};

export default LoginPage;
